<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Preview json</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close(false)"></button>
</div>
<div class="modal-body">
    <pre> {{json | json}}</pre>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-raised btn-secondary me-2" (click)="modal.close(false)">
        Close
    </button>
    <button type="button" class="btn btn-raised btn-success" (click)="modal.close(true)">
        Confirm
    </button>
</div>